import { CookieSettingsIcon } from './CookieSettingsIcon';

/**
 * author: Colton Wiscombe
 * id B8F9243C-188F-4EC1-9051-5BAA942D7F42
 * name cookie-settings
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-settings.svg
 * tags
 * - Food / Drink 
 * - Settings 
 */
export const BiscuitCrumbsIcon = CookieSettingsIcon;
export default BiscuitCrumbsIcon